import {
  Avatar,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Country, State, City } from "country-state-city";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MasterLayout from "../../../masterLayout/MasterLayout";
import { baseUrl } from "../../../helper/urls";
import EditIcon from "@mui/icons-material/Edit";
const StudentProfile = () => {
  const { token } = useSelector((state) => state.auth);
  const [profileData, setProfileData] = useState(null);
  console.log("profileData: ", profileData);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);


  const [profileConsent, setProfileConsent] = useState(0); // 0 unchecked, 1 checked
  const [consentError, setConsentError] = useState(false);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/students/getStudent`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setProfileData(response.data.data);
      const profile_consent = response.data.data?.profile_consent ?? 0;
      setProfileConsent(profile_consent)
    } catch (error) {
      console.error("Failed to fetch profile", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
    if (profileData?.country) {
      const countryObj = Country.getAllCountries().find(
        (c) => c.name === profileData.country
      );
      if (countryObj) {
        const stateList = State.getStatesOfCountry(countryObj.isoCode);
        setStates(stateList);

        const stateObj = stateList.find((s) => s.name === profileData.state);
        if (stateObj) {
          setCities(
            City.getCitiesOfState(countryObj.isoCode, stateObj.isoCode)
          );
        }
      }
    }
  }, [profileData?.country]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    const countryObj = Country.getAllCountries().find(
      (c) => c.name === countryName
    );
    setProfileData((prev) => ({
      ...prev,
      country: countryName,
      state: "",
      city: "",
    }));
    if (countryObj) {
      const stateList = State.getStatesOfCountry(countryObj.isoCode);
      setStates(stateList);
      setCities([]);
    }
  };

  const handleStateChange = (e) => {
    const stateName = e.target.value;
    const countryObj = Country.getAllCountries().find(
      (c) => c.name === profileData.country
    );
    const stateObj = State.getStatesOfCountry(countryObj?.isoCode || "").find(
      (s) => s.name === stateName
    );
    setProfileData((prev) => ({
      ...prev,
      state: stateName,
      city: "",
    }));
    if (countryObj && stateObj) {
      const cityList = City.getCitiesOfState(
        countryObj.isoCode,
        stateObj.isoCode
      );
      setCities(cityList);
    }
  };

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  console.log("imageUrl: ", imageUrl);
  console.log("image: ", image);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const imageUrl = URL.createObjectURL(file);
      setImageUrl(imageUrl);
    }
  };

  const handleSubmit = async () => {
    try {
      // Rule: If checkbox is checked but no image uploaded → show error and return
      if (profileConsent === 1 && !image) {
        setConsentError(true);
        toast.error("Please upload a profile image as you have given consent.");
        return;
      }

      const formData = new FormData();

      // Append text fields
      formData.append("firstName", profileData.firstName);
      formData.append("lastName", profileData.lastName);
      formData.append("schoolName", profileData.schoolName);
      formData.append("currentGrade", profileData.currentGrade);
      formData.append("country_code", profileData.country_code || "+91");
      formData.append("country", profileData.country);
      formData.append("state", profileData.state);
      formData.append("city", profileData.city);
      formData.append("address", profileData.address || "");
      formData.append("zipCode", profileData.zipCode || "");

      // Append checkbox value
      formData.append("profile_consent", profileConsent); // 0 or 1

      // Append image only if selected
      if (image) {
        formData.append("studentProfileImage", image);
      }

      const response = await axios.put(
        `${baseUrl}/api/students/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success === true) {
        toast.success("Profile updated successfully!");
        fetchProfile();
      }
    } catch (error) {
      toast.error("All fields are required");
      console.error("Update error:", error);
    }
  };

  return (
    <MasterLayout>
      <ToastContainer position="top-right" autoClose={2000} />
      {profileData ? (
        <Card>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
            <Box
              sx={{
                p: 3,
                // mt: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: 120,
                  height: 120,
                }}
              >
                <Avatar
                  src={imageUrl || `${baseUrl}${profileData.profileImage}`}
                  sx={{ width: 120, height: 120, border: "2px solid #ccc" }}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  id="profile-image-upload"
                  hidden
                />
                <label htmlFor="profile-image-upload">
                  <Tooltip title="Edit">
                    <IconButton
                      component="span"
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        boxShadow: 1,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </label>
              </Box>

              {/* Consent Checkbox centered below Avatar */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!profileConsent}
                    onChange={(e) => {
                      setProfileConsent(e.target.checked ? 1 : 0);
                      setConsentError(false);
                    }}
                  />
                }
                label="I consent to share my profile picture on DreamDor platform"
                sx={{ mt: 2 }} // optional spacing
              />
              {consentError && (
                <Typography variant="caption" color="error">
                  Profile image is required if you give consent.
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="First Name *"
                fullWidth
                name="firstName"
                value={profileData.firstName}
                onChange={handleChange}
                disabled
              />{" "}
              <TextField
                label="Last Name *"
                fullWidth
                name="lastName"
                value={profileData.lastName}
                onChange={handleChange}
                disabled
              />
            </Box>
            <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
              <Box sx={{ width: "50%" }}>
                <TextField
                  label="Email *"
                  fullWidth
                  name="email"
                  value={profileData.email}
                  disabled
                />
              </Box>
              <Box sx={{ width: "10%" }}>
                <TextField
                  label="Country Code *"
                  // fullWidth
                  name="country_code"
                  value={profileData.country_code}
                  disabled
                />
              </Box>
              <Box sx={{ width: "40%" }}>
                <TextField
                  label="Phone *"
                  fullWidth
                  name="phone"
                  value={profileData.phone}
                  disabled
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="School Name *"
                fullWidth
                name="schoolName"
                value={profileData.schoolName}
                onChange={handleChange}
              />
              <TextField
                label="Current Grade *"
                fullWidth
                name="currentGrade"
                value={profileData.currentGrade}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                select
                fullWidth
                label="Country *"
                value={profileData.country}
                onChange={handleCountryChange}
              >
                <MenuItem value="">Select Country</MenuItem>
                {countries.map((c) => (
                  <MenuItem key={c.isoCode} value={c.name}>
                    {c.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                fullWidth
                label="State *"
                value={profileData.state}
                onChange={handleStateChange}
                disabled={!states.length}
              >
                <MenuItem value="">Select State</MenuItem>
                {states.map((s) => (
                  <MenuItem key={s.isoCode} value={s.name}>
                    {s.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                fullWidth
                label="City *"
                name="city"
                value={profileData.city}
                onChange={handleChange}
                disabled={!cities.length}
              >
                <MenuItem value="">Select City</MenuItem>
                {cities.map((c) => (
                  <MenuItem key={c.name} value={c.name}>
                    {c.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            {/* <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="Zip Code"
                fullWidth
                name="zipCode"
                value={profileData.zipCode}
                onChange={handleChange}
              />
            </Box> */}

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="Zip Code *"
                fullWidth
                name="zipCode"
                value={profileData.zipCode}
                onChange={handleChange}
              />
              <TextField
                label="Address *"
                fullWidth
                name="address"
                value={profileData.address}
                onChange={handleChange}
                multiline
              // rows={3}
              />
            </Box>

            <Box textAlign="right">
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  backgroundColor: "#124178",
                  color: "white",
                  fontSize: 16,
                }}
              >
                Update Profile
              </Button>
            </Box>
          </Box>
        </Card>
      ) : (
        <Box p={3}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Box>
      )}
    </MasterLayout>
  );
};

export default StudentProfile;
